import React from "react";
import { Outlet } from "react-router-dom";
/** Components Import */
import Topbar from "./Shared/Topbar";
import Sidebar from "./Shared/Sidebar";
import Footer from "./Shared/Footer";

export default function Drawer() {
	return (
		<div id="wrapper">
			<Topbar />
			<Sidebar />
			<main id="main" className="main">
				<Outlet />
			</main>
			<Footer />
		</div>
	);
}
